import React, { useState, useRef, useEffect } from 'react';
import { apiRequest, API_CONSTANTS} from '../libs/apiRequest';
import { useNavigate } from 'react-router-dom';
import '../css/gtc-verify.css';

function GTCTwoFactor() {
    const navigate = useNavigate();
    const [code, setCode] = useState('');
    const [key, setKey] = useState(null);
    const requestRef = useRef(false);

    const handleRequestVerify = async () => {
        if (requestRef.current) {
            return;
        }
        requestRef.current = true;
        try {
            const form = new FormData();
            form.append("code", code);
            if (key) {
                form.append("key", key)
            }
            const res = await apiRequest({
                method: "POST",
                fn: "verify",
                api: API_CONSTANTS.PUBLIC_API,
                data: form
            })
            console.log(res)
            if (res && res.status == 200) {
                navigate("/home")
                window.location.reload();
            } else {
                alert("Something went wrong. Please try to login again.");
                navigate("/login");
            }
        } catch (error) {
            console.log("handleRequestUserInfo", error)
        }
        requestRef.current = false;
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
		const verifyKey = params.get("verifykey") || null;
        setKey(verifyKey);
    }, [])

    return (
        <div className="verify-page">
            <div className="verify-container">
                <div className="verify-card">
                    <div className="verify-header">
                        <h1 className="verify-title">
                            <span style={{ color: "var(--secondary-color)" }}>Go</span>
                            Trycatch
                        </h1>
                        <h2 className="verify-subtitle">Two-Factor Authentication</h2>
                        <p className="verify-description">
                            Please enter the verification code sent to your email address
                        </p>
                    </div>

                    <div className="verify-form">
                        <div className="code-input-group">
                            <label className="code-label">Verification Code</label>
                            <input 
                                className="code-input"
                                type="text"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                placeholder="Enter code"
                                maxLength={6}
                            />
                        </div>

                        <a 
                            className="verify-button"
                            onClick={handleRequestVerify}
                        >
                            Verify Code
                        </a>

                        <p className="verify-info">
                            Didn't receive the code? Check your spam folder or{' '}
                            <a href="/login" className="login-link">try logging in again</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}   

export default GTCTwoFactor;